<template>
  <el-config-provider :locale="zhCn">
    <!-- <router-view v-slot="{ Component }">
      <keep-alive :include="['ChatPlus']">
        <component :is="Component" />
      </keep-alive>
    </router-view> -->
    <router-view />
  </el-config-provider>
</template>

<script setup>
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
// 下拉切换之后报错
const debounce = (fn, delay) => {
  let timer;
  return (...args) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 200);
    super(callback);
  }
};
</script>


<style lang="stylus">
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  margin: 0 !important;
  padding: 0 !important;
  font-family: PingFangSC-Medium, PingFang SC;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  min-width: 980px;
}

.el-overlay-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  .el-dialog {
    margin: 0;

    .el-dialog__body {
      max-height: 90vh;
    }
  }
}

.el-select-dropdown__footer {
  padding: 0 10px 10px;
  border-top-color: transparent;
}
</style>
